// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Layout, Row, Button, Icon, Popover, Tag } from "antd";
import Slider from "react-slick";
import Media from "react-media";
import { Player } from "video-react";
import "video-react/dist/video-react.css";
import DownloadBtn from "../downloadbtn";
import ShareBtn from "../shareBtn";
import * as actions from "../../actions";
import { getPrevNextItem } from "../../selectors";
import type { State } from "../../types/store";
import type { Entities } from "../../types/entities";
import "./details.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const { Content, Header } = Layout;

type Props = {
  entities: Entities,
  selectedItem?: Object,
  typologyById: Object,
  tagById: Object,
  history: Object,
  location: Object,
  match: Object,
  nav: Object,
  onResetSelectedItem: Function,
  onGetItem: Function,
  onGetPrevNextItem: Function,
  onGetPrevNextItem: Function
};

class DetailsView extends Component<Props> {
  thumbs: Slider;
  componentDidMount() {
    // console.log("this.props.location ", this.props.location);
    const { match } = this.props;
    this.getItemFromID(match.params.itemId);
  }

  getItemFromID(id) {
    const { selectedItem, onGetItem, entities } = this.props;
    if (selectedItem !== null && selectedItem !== undefined) {
      const index = entities.all.indexOf(selectedItem.id);
      setTimeout(() => this.thumbs.slickGoTo(index), 300);
    } else {
      onGetItem(id);
    }
  }

  formatDate = (date: string): string => {
    const _date = new Date(date);
    return _date.toLocaleDateString();
  };

  onBack = () => {
    const { onResetSelectedItem } = this.props;
    onResetSelectedItem(null);
  };

  onPrev = () => {
    this.thumbs.slickPrev();
    const { nav, onGetPrevNextItem } = this.props;
    onGetPrevNextItem(nav.prevItem);
  };

  onNext = () => {
    this.thumbs.slickNext();
    const { nav, onGetPrevNextItem } = this.props;
    onGetPrevNextItem(nav.nextItem);
  };

  onSelectThumb = id => {
    const { onGetPrevNextItem, entities } = this.props;
    onGetPrevNextItem(entities.byId[id]);
  };

  render() {
    const { tagById, entities, selectedItem, nav } = this.props;
    let type = "image";
    if (selectedItem) {
      const index = selectedItem.previewType.indexOf("/");
      type = selectedItem.previewType.substring(0, index);
      // console.log("selectedItem ", type);
    }
    return (
      <Layout className="details">
        <Header style={{ position: "fixed", width: "100%" }}>
          {selectedItem && (
            <Media query="(max-width: 768px)">
              {matches => (
                <Row type="flex" justify="space-between" align="middle">
                  <Button type="default" onClick={this.onBack}>
                    <Link to="/search">
                      <Icon type="left" />
                      {matches ? "" : "Back"}
                    </Link>
                  </Button>
                  <h2 className="details-title">{selectedItem.name}</h2>

                  {!matches ? (
                    <Popover
                      overlayClassName="popover-item-info"
                      placement="bottomRight"
                      getPopupContainer={triggerNode => triggerNode.parentNode}
                      content={
                        <div>
                          <h4>{this.formatDate(selectedItem.publishDate)}</h4>
                          {selectedItem.tags &&
                            selectedItem.tags.map(tag => {
                              return (
                                <Tag
                                  key={tag}
                                  className="item-tag"
                                  color="#999"
                                >
                                  {tagById && tagById[tag].name}
                                </Tag>
                              );
                            })}
                        </div>
                      }
                    >
                      <Button className="menu-btn">
                        <Icon type="info-circle-o" />
                      </Button>
                    </Popover>
                  ) : null}
                  <DownloadBtn
                    direction="down"
                    files={selectedItem.files}
                    label={matches ? "" : "Download"}
                  />
                  <ShareBtn
                    direction="up"
                    clsName="btn-white"
                    files={selectedItem.files}
                  />
                </Row>
              )}
            </Media>
          )}
        </Header>
        <Content className="details-content">
          {selectedItem && (
            <div className="details-wrapper">
              <Media query="(max-width: 768px)">
                {matches => (
                  <div className="thumbs-wrapper">
                    <Button
                      className="nav-bnt"
                      type="default"
                      disabled={nav.prevItem === null}
                      size="large"
                    >
                      <Link
                        to={`/details/${
                          nav.prevItem !== null ? nav.prevItem.id : ""
                        }`}
                        onClick={this.onPrev}
                      >
                        <Icon type="left" />
                        {/* {matches ? "" : "Prev"} */}
                      </Link>
                    </Button>
                    <div className="thumbs">
                      <Slider
                        ref={node => (this.thumbs = node)}
                        autoplay={false}
                        speed={500}
                        slidesToShow={5}
                        slidesToScroll={1}
                        arrows={false}
                        responsive={[
                          { breakpoint: 768, settings: { slidesToShow: 3 } },
                          { breakpoint: 1024, settings: { slidesToShow: 5 } }
                        ]}
                      >
                        {entities.all.map(itemId => {
                          const item = entities.byId[itemId];

                          return (
                            <Link
                              key={itemId}
                              to={`/details/${itemId}`}
                              onClick={() => this.onSelectThumb(itemId)}
                            >
                              <div
                                className={
                                  "thumb-image " +
                                  (itemId === selectedItem.id ? "active" : "")
                                }
                                style={{
                                  backgroundImage: `url(${item.thumbUrl})`
                                }}
                              />
                            </Link>
                          );
                        })}
                      </Slider>
                    </div>
                    <Button
                      className="nav-bnt"
                      type="default"
                      disabled={nav.nextItem === null}
                      size="large"
                    >
                      <Link
                        to={`/details/${
                          nav.nextItem !== null ? nav.nextItem.id : ""
                        }`}
                        onClick={this.onNext}
                      >
                        {/* {matches ? "" : "Next"} */}
                        <Icon type="right" />
                      </Link>
                    </Button>
                  </div>
                )}
              </Media>
              {type === "image" ? (
                <ImageViewer imageUrl={selectedItem.previewUrl} />
              ) : (
                <Player
                  playsInline
                  src={selectedItem.previewUrl}
                  poster={selectedItem.previewPosterUrl}
                  className="detail-video vjs-big-play-centered"
                />
              )}
            </div>
          )}
        </Content>
      </Layout>
    );
  }
}

const ImageViewer = ({ imageUrl }) => (
  <div
    className="detail-image"
    style={{ backgroundImage: `url(${imageUrl})` }}
  />
);

function mapStateToProps(state: State) {
  const { entities, selectedItem } = state.items;
  const { byId: typologyById } = state.filters.mainFilters.typologies.entities;
  const { byId: tagById } = state.filters.byTypology.tags.entities;
  return {
    entities,
    selectedItem,
    typologyById,
    tagById,
    nav: getPrevNextItem(state.items)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onResetSelectedItem: bindActionCreators(actions.selectItem, dispatch),
    onGetPrevNextItem: bindActionCreators(actions.selectItem, dispatch),
    onGetItem: bindActionCreators(actions.getItemById, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailsView);

DetailsView.propTypes = {
  entities: PropTypes.object.isRequired,
  selectedItem: PropTypes.object,
  typologyById: PropTypes.object,
  tagById: PropTypes.object,
  nav: PropTypes.object,
  onResetSelectedItem: PropTypes.func.isRequired,
  onGetItem: PropTypes.func.isRequired,
  onGetPrevNextItem: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/detailsview/index.js